import { Button, Slider, Stack, Typography } from "@mui/material";
import { useDebouncedCallback } from "use-debounce";
import * as React from "react";
import { generateBorder } from "../../../lib/generateBorder";
import { generateRadius } from "../../../lib/generateRadius";
import { PricingFilterProps } from "../../../utils/interfaces/core/PricingFilterProps";

const PricingFilter: React.FC<PricingFilterProps> = ({
  pricingMode = "column",
  pricingHandlerBorder = { width: "3px" },
  pricingHandlerWidth = "20px",
  pricingHandlerHeight = "20px",
  pricingHandlerRadius,
  pricingHandlerColor = "#FFFFFF",
  pricingLineHeight = "3px",
  pricingLineColor = "#EEEEEE",
  pricingHoverHandlerColor = "#FFFFFF",
  pricingActiveLineHeight = "3px",
  pricingActiveLineColor = "#000000",
  pricingBtnColor = "#000000",
  pricingBtnTextColor = "#FFFFFF",
  pricingBtnHoverColor = "#000000",
  pricingBtnHoverTextColor = "#FFFFFF",
  pricingHoverHandlerBorder,

  /**
   * FOR EDITION
   */
  onChange,
  urlParams = {},
}) => {
  const [value, setValue] = React.useState<number[]>([
    urlParams.mn ?? 0,
    urlParams.mx ?? 1000000,
  ]);

  React.useEffect(() => {
    if (urlParams.mn || urlParams.mx) {
      setValue([urlParams.mn ?? 0, urlParams.mx ?? 1000000]);
    }
  }, [urlParams]);

  const handleChange = async (newValue: number | number[]) => {
    if (pricingMode === "auto" && onChange) {
      await onChange({ mn: newValue[0], mx: newValue[1] });
    }
  };

  const debounced = useDebouncedCallback((value: number[]) => {
    handleChange(value);
  }, 300);

  const price = (
    <Typography>
      Prix: {value[0]} F CFA - {value[1]} F CFA
    </Typography>
  );

  return (
    <Stack
      id="PricingFilter"
      sx={{
        "&#PricingFilter": {
          "& .MuiButtonBase-root": {
            bgcolor: pricingBtnColor,
            color: pricingBtnTextColor,

            "&:hover": {
              bgcolor: pricingBtnHoverColor,
              color: pricingBtnHoverTextColor,
            },
          },
          "& .MuiSlider-root": {
            color: pricingActiveLineColor,

            "& .MuiSlider-rail": {
              height: pricingLineHeight,
              backgroundColor: pricingLineColor,
            },

            "& .MuiSlider-track": {
              height: pricingActiveLineHeight,
            },

            "& .MuiSlider-thumb": {
              border: generateBorder(pricingHandlerBorder),

              bgcolor: pricingHandlerColor,
              width: pricingHandlerWidth,
              height: pricingHandlerHeight,
              borderRadius: generateRadius(pricingHandlerRadius, "50%"),

              "&:hover": {
                borderColor: generateBorder(pricingHoverHandlerBorder),
                bgcolor: pricingHoverHandlerColor,
              },
            },
          },
        },
      }}
      spacing={1}
    >
      <Slider
        getAriaLabel={() => "Temperature range"}
        value={value}
        onChange={(_, v) => {
          setValue(v as number[]);
          debounced(v as number[]);
        }}
        valueLabelDisplay="auto"
        sx={{ mx: "10px", width: "calc(100% - 20px)" }}
        step={500}
        max={1000000}
      />
      {pricingMode !== "auto" ? (
        <Stack
          direction={pricingMode}
          alignItems="flex-start"
          spacing={1}
          justifyContent="space-between"
        >
          {price}
          <Button
            disableElevation
            variant="contained"
            color="inherit"
            size="small"
            // todo handler loading
            onClick={async () => {
              if (onChange) {
                await onChange({
                  mn: value[0],
                  mx: value[1],
                });
              }
            }}
          >
            Filtrer
          </Button>
        </Stack>
      ) : (
        price
      )}
    </Stack>
  );
};

export default PricingFilter;
